import { ISpeechService } from 'src/services/SpeechService/ISpeechService'
import { Scenes } from '../constants/game'
import { IExecutor } from './IExecutor'
import { VictimService } from 'src/services/VictimService/VictimService'
import { AudioQueueManager } from 'src/services/AudioQueueManagerService/AudioQueueManagerService'
import { buildVerdict, Verdict } from 'src/utils/buildVerdict'
import { runsService } from 'src/services/RunsService/RunsService'

/**
 * End of a run: one card, one zinger, one button. Nothing auto-advances —
 * this is the screen people stop on, read, and (on the web) copy.
 */
export class VerdictSceneExecutor extends IExecutor {
  private setScene: (scene: Scenes) => void
  private speech: ISpeechService
  private audioQueueManager: AudioQueueManager
  private victimService: VictimService
  private verdict: Verdict | null = null

  constructor(
    setScene: (scene: Scenes) => void,
    speech: ISpeechService,
    audioQueueManager: AudioQueueManager,
    victimService: VictimService,
  ) {
    super()
    this.setScene = setScene
    this.speech = speech
    this.audioQueueManager = audioQueueManager
    this.victimService = victimService
  }

  public exec = async () => {
    console.log('🐄 VerdictSceneExecutor exec')
  }

  /** Computed once per run so the card and the spoken line agree. */
  public getVerdict = (): Verdict => {
    if (!this.verdict) {
      this.verdict = buildVerdict(
        this.victimService.getRunTally(),
        this.victimService.getTagTally(),
      )
    }
    return this.verdict
  }

  public sayVerdict = async () => {
    const verdict = this.getVerdict()
    runsService.record(verdict.grade)
    this.audioQueueManager.enqueue(() => this.speech.speak(verdict.zinger))
  }

  public playAgain = () => {
    this.audioQueueManager.clearPending()
    this.speech.cancelActive()
    this.victimService.resetRun()
    this.verdict = null
    // The next pair was already lined up (and preloaded) during the last
    // sentencing, so the new run starts on a fresh matchup instantly.
    this.setScene(Scenes.WhoLivesQuestion)
  }
}
